import * as React from "react";
import {useState, useEffect} from "react";
import PropTypes from "prop-types";
import {useTheme} from "@mui/material/styles";
import {AppBar, Card, Grid, Divider, Tooltip} from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import {DataGrid, GridActionsCellItem} from "@mui/x-data-grid";
import {GET} from "APIclient";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import PrintIcon from "@mui/icons-material/Print";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";

export default function AppointmentList() {
  const theme = useTheme();
  const [appointments, setAppointments] = useState([]);
  const [paginationModel, setPaginationModel] = useState({page: 0, pageSize: 10});
  const [totalItems, setTotalItems] = useState(0);

  const columns = [
    {field: "id", headerName: "#", width: 30},
    {field: "empName", headerName: "Employee Name", width: 180},
    {field: "empId", headerName: "Employee ID", width: 120},
    {field: "mobileNo", headerName: "Mobile No", width: 150},
    {field: "designation", headerName: "Designation", width: 180},
    {field: "joinDate", headerName: "Joining Date", width: 150},
    {
      field: "actions",
      headerName: "Action",
      width: 130,
      renderCell: params => renderActions(params)
    }
  ];

  const renderActions = params => {
    return (
      <>
        <Tooltip title="Download PDF" arrow>
          <GridActionsCellItem
            key={`download-pdf-${params.id}`}
            icon={<PictureAsPdfIcon />}
            label="Download PDF"
            color="primary"
            // onClick={() => handleDownloadPDF(params.row)}
          />
        </Tooltip>
        <Tooltip title="Print Appointment" arrow>
          <GridActionsCellItem
            key={`print-${params.id}`}
            icon={<PrintIcon />}
            label="Print"
            color="primary"
            onClick={() => handlePrint(params.row)}
          />
        </Tooltip>
      </>
    );
  };

  const fetchAppointments = async (page = 0, pageSize = 20) => {
    try {
      // const url = `admin/getAppointmentList?offset=${page * pageSize}&limit=${pageSize}`;
      const url = `admin/getAppointmentList`;
      const response = await GET(url);

      if (response.status === 200) {
        const data = response.data.content;

        let index = 1;
        // Format the data for the DataGrid
        const formattedData = data.map(item => ({
          id: index++,
          // id: item.offerLetterId,
          empName: `${item.firstName} ${item.lastName}`,
          empId: item.empId,
          mobileNo: item.mobileNo,
          designation: item.designation,
          joinDate: item.joinDate
        }));

        setAppointments(formattedData);
        setTotalItems(response.data.totalElements);
      }
    } catch (error) {
      console.error("Error fetching appointments:", error);
    }
  };

  // Fetch data when component mounts or pagination changes
  useEffect(() => {
    fetchAppointments(paginationModel.page, paginationModel.pageSize);
  }, [paginationModel]);

  // function to handle the printing of an appointment's details
  const handlePrint = row => {
    const printWindow = window.open("", "_blank");
    const content = `
      <html>
        <head>
          <title>Appointment Details</title>
          <style>
            body { font-family: Arial, sans-serif; }
            .container { padding: 20px; }
            .header { font-size: 20px; font-weight: bold; margin-bottom: 20px; }
            .details { margin-bottom: 10px; }
          </style>
        </head>
        <body>
          <div class="container">
            <div class="header">Appointment Details</div>
            <div class="details"><strong>Employee Name:</strong> ${row.empName}</div>
            <div class="details"><strong>Employee ID:</strong> ${row.empId}</div>
            <div class="details"><strong>Mobile No:</strong> ${row.mobileNo}</div>
            <div class="details"><strong>Designation:</strong> ${row.designation}</div>
            <div class="details"><strong>Joining Date:</strong> ${row.joinDate}</div>
          </div>
        </body>
      </html>
    `;
    printWindow.document.write(content);
    printWindow.document.close();
    printWindow.print();
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox>
        <AppBar position="static">
          <Card></Card>
        </AppBar>
        <MDBox pt={3} px={3}>
          <Card>
            <MDBox p={2}>
              <MDTypography variant="h5">Appointment List</MDTypography>
            </MDBox>
            <MDBox p={1}>
              <Grid container spacing={3}>
                <Grid item xs={12} lg={12}>
                  <DataGrid
                    rows={appointments}
                    columns={columns}
                    paginationModel={paginationModel}
                    pageSizeOptions={[20]}
                    onPaginationModelChange={setPaginationModel}
                    pagination
                    rowCount={totalItems}
                    loading={appointments.length === 0}
                    page={paginationModel.page}
                    pageSize={paginationModel.pageSize}
                    sx={{border: 0}}
                  />
                </Grid>
              </Grid>
            </MDBox>
            <Divider />
          </Card>
        </MDBox>
      </MDBox>
    </DashboardLayout>
  );
}
